import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { externalTrainingListRes, externalTrainingListTodo } from '../../LMS_Redux/LMS_Slices/Course/ExternalTrainingList'
import { PropagateLoader } from 'react-spinners'
import DataTables from '../LMS_DATA_TABLE/DataTable'
import { IoInformationCircleOutline } from 'react-icons/io5'
import { FaEye } from 'react-icons/fa6'
import { MdOutlineCancel } from "react-icons/md";
import { MdOutlineCheckCircle } from "react-icons/md";
import { Tooltip } from 'react-tooltip'
import { extTrainingApprovalRes, extTrainingApprovalTodo } from '../../LMS_Redux/LMS_Slices/Course/ExternalTrainingApproval'
import Swal from 'sweetalert2'
import { Modal } from 'react-bootstrap'
import moment from 'moment'

export default function ExternalTrainingList() {

    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false)
    const [modalData, setModalData] = useState()
    const dispatch = useDispatch()
    const data = useSelector(state => state.externalTrainingList && state.externalTrainingList.data && state.externalTrainingList.data.data)
    // console.log(data)

    const mergedArray = data && data.externalTrainingList && data.externalTrainingList.map((item) => {
        const user = data && data.userList && data.userList.find((obj) => obj.vemp_code === item.fk_user_id);
        return { ...item, user, name_and_code: user ? `${user.vemp_fname} - (${user.vemp_company_code})` : null };
    })

    // console.log(mergedArray)

    const handleClose = () => { setShow(false) }
    const handleShow = (data) => { setModalData(data); setShow(true) }

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        role === 'Learner' ? null :
            {
                headerName: 'USER NAME',
                field: 'name_and_code',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: true,
                // wrapText: true,
                // autoHeight: true,
            },
        {
            headerName: 'TITLE',
            field: 'ext_training_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'AGENCY',
            field: 'training_agency',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DESCRIPTION',
            field: 'training_program_detail',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'training_status',
            cellRenderer: params => params.value == 'approved' ? <span className='badge text-bg-success text-capitalize'>{params.value}</span> : params.value == 'rejected' ? <span className='badge text-bg-danger text-capitalize'>{params.value}</span> : <span className='badge text-bg-warning text-capitalize'>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline size={20} className='eye'
                        onClick={() => handleShow(params.data)}
                        data-tooltip-id='details'
                        data-tooltip-content="External Training Details!"
                        data-tooltip-place="bottom"
                    />
                    {role == 'Admin' && params.data.training_status == 'pending' ?
                        <>
                            <MdOutlineCheckCircle size={20} className='edit ms-3'
                                onClick={() => change_status(params, 'approved')}
                                data-tooltip-id='edit'
                                data-tooltip-content="Approve!"
                                data-tooltip-place="bottom"
                            />
                            <MdOutlineCancel size={20} className='delete ms-3'
                                onClick={() => change_status(params, 'rejected')}
                                data-tooltip-id='delete'
                                data-tooltip-content="Reject!"
                                data-tooltip-place="bottom"
                            />
                        </>
                        : ''
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='edit' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='delete' style={{ backgroundColor: "rgb(239, 61, 80)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ])

    const change_status = (params, status) => {
        Swal.fire({
            title: `External Training Approval`,
            text: `Are you sure want to ${status} External Training?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(params.data)
                // setLoading(true)
                dispatch(extTrainingApprovalTodo({ 'external_id': params.data.id, 'user': params.data.fk_user_id, 'approval_status': status })).then(() => change_status_res())
            }
        })
    }

    const change_status_res = () => {
        if (extTrainingApprovalRes && extTrainingApprovalRes.success) {
            Swal.fire(
                'Approval Status',
                extTrainingApprovalRes.message,
                'success'
            )
            setLoading(true)
            dispatch(externalTrainingListTodo()).then(() => ext_training_res())
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: extTrainingApprovalRes.message,
            })
        }
    }

    const ext_training_res = () => {
        if (externalTrainingListRes && externalTrainingListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(externalTrainingListTodo()).then(() => ext_training_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <span className='icon2'>External Training List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={mergedArray}
                        // columnDefs={columnDefs}
                        columnDefs={columnDefs.filter((colDef) => colDef !== null)}
                    />
                }
            </div>

            <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>External Training Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {role === 'Learner' ? '' :
                        <div className='d-flex justify-content-between align-items-baseline'>
                            <span style={{ color: 'rgb(157, 157, 157)' }}>User</span>
                            <h6>{`${modalData?.user?.vemp_fname} - (${modalData?.user?.vemp_company_code})`}</h6>
                        </div>
                    }

                    <div className='d-flex justify-content-between align-items-baseline'>
                        <span style={{ color: 'rgb(157, 157, 157)' }}>External Training Title</span>
                        <h6>{modalData && modalData.ext_training_title}</h6>
                    </div>

                    <div className='d-flex justify-content-between align-items-baseline'>
                        <span style={{ color: 'rgb(157, 157, 157)' }}>Training Agency</span>
                        <h6>{modalData && modalData.training_agency}</h6>
                    </div>

                    <div className='d-flex justify-content-between align-items-baseline'>
                        <span style={{ color: 'rgb(157, 157, 157)' }}>Training Date</span>
                        <h6>{modalData?.training_date && moment(modalData?.training_date).format('DD/MM/YYYY')}</h6>
                    </div>

                    <div className='d-flex justify-content-between align-items-baseline'>
                        <span style={{ color: 'rgb(157, 157, 157)' }}>Training Duration (In Days)</span>
                        <h6>{modalData && modalData.training_duration}</h6>
                    </div>

                    <div className='d-flex justify-content-between align-items-baseline'>
                        <span style={{ color: 'rgb(157, 157, 157)' }}>Approval Status</span>
                        <p>
                            {modalData && modalData.training_status == 'approved' ? <span className='badge text-bg-success text-capitalize'>{modalData && modalData.training_status}</span> : modalData && modalData.training_status == 'rejected' ? <span className='badge text-bg-danger text-capitalize'>{modalData && modalData.training_status}</span> : <span className='badge text-bg-warning text-capitalize'>{modalData && modalData.training_status}</span>}
                        </p>
                    </div>

                    <div className=''>
                        <span style={{ color: 'rgb(157, 157, 157)' }}>Training Description</span>
                        <h6>{modalData && modalData.training_program_detail}</h6>
                    </div>

                    <div className='d-flex justify-content-between align-items-baseline'>
                        <span style={{ color: 'rgb(157, 157, 157)' }}>Training Certificate</span>
                        <a href={modalData && process.env.REACT_APP_IMAGE_URL + modalData.training_proof} target="_blank" className='btn btn_submit' rel="noopener noreferrer">
                            <FaEye size={20} className='' />
                        </a>
                    </div>

                    {modalData && modalData.other_documents ?
                        <div className='d-flex justify-content-between align-items-baseline mt-1'>
                            <span style={{ color: 'rgb(157, 157, 157)' }}>Other Document</span>

                            <a href={modalData && process.env.REACT_APP_IMAGE_URL + modalData.other_documents} target="_blank" className='btn btn_submit' rel="noopener noreferrer">
                                <FaEye size={20} className='' />
                            </a>

                        </div>
                        : ''
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
